import './js/scaleRoot.2.js';
import './js/scrollFrame.2.js';
import { MJPromotion } from './js/promotion2.js'

import lozad from 'lozad';

class Boot {
  getElementsDevice() {
    const elPc = $('.MS__pc');
    const elMb = $('.MS__mb');
    if (varMS.onlyPC) {
      elMb.remove();
      console.log('Remove MS__mb:', elMb.length);
    } else {
      
    
      const isMobile = window.matchMedia("only screen and (max-width: 768px) and (orientation: portrait)").matches;
      if (isMobile) {
        elPc.remove();
        console.log('Remove MS__pc:', elPc.length);
      } else {
        elMb.remove();
        console.log('Remove MS__mb:', elMb.length);
      }
    }
  };
  removeLayerLoading() {
    setTimeout(() => {
      $('.MS__layer-loading, .layer').hide();
      console.log('Element Layer hidden');
    }, 4000);
  }
  onScale(callback) {
    $("#MS__wrapper, .MS__outer").addClass("scaleDesktop scaleMobile");
    window.addEventListener("load", function () {
      console.log('HTML,CSS,JS loaded');
      $("#MS__wrapper, .MS__outer").scalePlatform(callback);

    });
    $(window).on("resize", function () {
      $("#MS__wrapper, .MS__outer").scalePlatform();
    });

    let $firstImg;
    if (varMS.onlyPC) {
      $firstImg = $('#MS__wrapper section .background img.MS__pc').first();
    }
    else {
      const isMobile = window.matchMedia("only screen and (max-width: 768px) and (orientation: portrait)").matches;
      if (isMobile) {
        $firstImg = $('#MS__wrapper section .background img.MS__mb').first();
      } else {
        $firstImg = $('#MS__wrapper section .background img.MS__pc').first();
      }
    }

    if (!$firstImg || $firstImg.length === 0) {
      console.warn('No first image found, skipping applySize logic.');
      return;
    }

    function applySize() {
      $('.MJ__readyScale').css({
        position: 'relative',
        zIndex: '10',
        width: $firstImg.width() + 'px',
        height: $firstImg.height() + 'px'
      });
      $("#MS__wrapper, .MS__outer").scalePlatform();
      console.log('First image loaded - scalePlatform triggered');
    }

    if ($firstImg[0].complete) {
      applySize(); // ảnh đã load sẵn
    } else {
      $firstImg.on('load', applySize); // chờ load mới xử lý
    }


  };
  async lazyLoad() {
    console.log("Found elements lazyloads:", $('.MS__lazyload, .MJ__lazyload').length);
    const observer = lozad('.MS__lazyload, .MJ__lazyload', {
      loaded: function (el) {
        el.classList.add('MJ__loaded', 'MJ__lazyload');

      }
    });
    observer.observe();
    console.log("Lozad loaded successfully");
  };
  async disableHref() {
    $('a[href="#"]').on('click', function (event) {
      var hrefValue = $(this).attr('href');
      if (hrefValue === '#') {
        event.preventDefault();
      }
    });
  };
  loadBundles() {
    const listBundles = varMS.bundles;

    const loadScript = (src, globalVar) => {
      if (window[globalVar]) {
        console.log(`${globalVar} already loaded from CDN`);
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        console.log(`${globalVar} loaded successfully`);
      };
      script.onerror = () => console.error(`Failed to load ${src}`);
      document.head.appendChild(script);
    };

    const loadCSS = (href) => {
      if (document.querySelector(`link[href="${href}"]`)) {
        console.log(`CSS already loaded: ${href}`);
        return;
      }
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => {
        console.log(`CSS loaded: ${href}`);
      };
      link.onerror = () => console.error(`Failed to load CSS: ${href}`);
      document.head.appendChild(link);
    };

    for (const key in listBundles) {
      if (listBundles[key] === false) continue;
      try {
        switch (key) {
          case 'jquery':
            window.$ = jQuery;
            break;
          case 'lodash':
            loadScript("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/lodash.min.js", "_");
            break;
          case 'swiper':
            loadScript("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/swiper-bundle.min.js", "Swiper");
            loadCSS("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/swiper-bundle.min.css");
            break;
          case 'fancybox':
            loadScript("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/fancybox.umd.min.js", "Fancybox");
            loadCSS("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/fancybox.min.css");
            break;
          case 'animate':
            loadCSS("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/vendor/animate.min.css");
            break;
        }
      } catch (error) {
        console.error(`Failed to load ${key} from CDN:`, error);
      }
    }
  }
  loadModules() {
    const listModules = varMS.modules || {};
    const loadModuleScript = (src, globalVar) => {
      if (!src) return;
      if (globalVar && window[globalVar]) {
        console.log(`[modules] ${globalVar} already available`);
        return;
      }
      if (document.querySelector(`script[src="${src}"]`)) {
        console.log(`[modules] Script already loaded: ${src}`);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => console.log(`[modules] Loaded: ${src}`);
      script.onerror = () => console.error(`[modules] Failed to load: ${src}`);
      document.head.appendChild(script);
    };

    if (!listModules || typeof listModules !== 'object') {
      console.warn('No module configuration found, skip loadModules()');
      return;
    }

    for (const key in listModules) {
      if (listModules[key] === false) continue;

      const moduleCfg = listModules[key];
      try {
        switch (key) {
          case 'languages':
            loadModuleScript("https://cdn-mainsite-aka.vnggames.com/products/libraryMainsite/prod-source/1.1.1/assets/main/js/_language-v2.js");
            break;
          default: {
            if (typeof moduleCfg === 'string') {
              loadModuleScript(moduleCfg);
            } else if (moduleCfg && typeof moduleCfg === 'object' && moduleCfg.src) {
              loadModuleScript(moduleCfg.src, moduleCfg.global);
            } else {
              console.warn(`[modules] No loader for key: ${key}`);
            }
            break;
          }
        }
      } catch (error) {
        console.error(`Failed to load module ${key}:`, error);
      }
    }
  }
  run() {
    this.loadBundles();
    this.loadModules();
    this.getElementsDevice()
    this.removeLayerLoading();
    this.onScale(() => new libraryMJ().loadVideo())
    this.disableHref();
    this.lazyLoad();
  }
};
class libraryMJ {
  onClosePopup() {
    $('.MJ__close-popup').on('click', function (e) {
      $(this).closest('.MS__popup').removeClass("active");
      return false;
    });
  };
  onToogleActive() {
    $(".MJ__toogleActive").on("click", function (e) {
      const target = $(this).data("target");
      $(target).toggleClass("active");
      e.preventDefault();
      return false;
    });
  };
  onOpenIframe() {
    $('.MJ__openIframe').on("click", function (e) {
      const linkIframe = $(this).data("link");
      const targetIframe = $(this).data("iframe");
      $(targetIframe).attr('src', linkIframe);
      e.preventDefault();
      return false;
    });
  };
  loadVideo() {
    const listVideos = $('.MJ__loadVideo');
    if (listVideos.length === 0) return;

    listVideos.each(function (index, element) {
      const $this = $(this);

      // Nếu đã có thẻ <video> bên trong thì bỏ qua
      if ($this.find('video').length > 0) return;

      const videoSrc = $this.data('video');
      $this.append(`
      <video width="100%" height="auto" playsinline muted autoplay loop loading="lazy" style="position: absolute; top: 0; left: 0;">
        <source src="${videoSrc}">
      </video>
    `);
    });
  }
  run() {
    this.onClosePopup();
    this.onToogleActive();
    this.onOpenIframe();
  }
};
class Core {
  constructor() {
    this.init();
  };
  promotion(object) {
    new MJPromotion(object);
  };
  tracking(trigger = 'ready', options = {}) {
    const { gaIds = [], gtmIds = [], fbPixelIds = [] } = options || {};

    const loadScript = (src, async = true) => {
      return new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = src;
        s.async = async;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error(`Failed to load: ${src}`));
        document.head.appendChild(s);
      });
    };

    const initTracking = async () => {
      if (gaIds.length > 0) {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        window.gtag = gtag;

        try {
          await loadScript(`https://www.googletagmanager.com/gtag/js?id=${gaIds[0]}`);
          gtag("js", new Date());

          gaIds.forEach(id => {
            gtag("config", id, { send_page_view: true });
          });
        } catch (error) {
        }
      }

      if (gtmIds.length > 0) {
        for (let id of gtmIds) {
          try {
            await loadScript(`https://www.googletagmanager.com/gtm.js?id=${id}`);
          } catch (error) {
          }
        }
      }

      if (fbPixelIds.length > 0) {
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = "2.0";
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        fbPixelIds.forEach(id => {
          fbq("init", id);
        });
        fbq("track", "PageView");
      }
    };

    const runTracking = () => {
      initTracking();
    };

    if (trigger === 'load') {
      if (document.readyState === 'complete') {
        runTracking();
      } else {
        window.addEventListener('load', runTracking, { once: true });
      }
    } else {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runTracking, { once: true });
      } else {
        runTracking();
      }
    }
  };
  init() {
    new Boot().run()
    new libraryMJ().run()
  };
}

window.libraryMainsite = new Core();
